import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { modalState } from '@/state/modal.state';
import { Modal } from '@/ui/modal/modal';
import { useRejectProjectRequest } from '@/features/projects/hooks/use-reject-project-request.mutation';
import { useAtom } from 'jotai';

export const RejectProjectRequestModal = () => {
  const [modal, setModal] = useAtom(modalState);
  const { t } = useTranslation('request-project');
  const rejectMutation = useRejectProjectRequest();

  if (!modal || modal.state !== 'rejectProjectRequest') return null;

  const close = () => {
    setModal(null);
  };

  const handleRejectRequest = () => {
    rejectMutation.mutate(modal.requestId, {
      onSuccess: () => {
        close();
      },
    });
  };

  return (
    <Modal
      header={t`rejectModal.title`}
      onClose={close}
      mainAction={{
        label: t`rejectModal.confirm`,
        onClick: handleRejectRequest,
      }}
      secondaryAction={{
        label: t`default:cancel`,
        onClick: close,
      }}
      loading={rejectMutation.isPending}
      disabled={rejectMutation.isPending}
      variant="danger"
    >
      <Container>
        <Description>{t`rejectModal.description`}</Description>
      </Container>
    </Modal>
  );
};

const Container = styled('div')`
  height: 100px;
`;

const Description = styled('div')`
  color: ${({ theme }) => theme.colors.gray.c12};
  font-family: ${({ theme }) => theme.fonts.neue};
  font-size: 14px;
  line-height: 145%;
  letter-spacing: 0.03em;
`;
